import { render, staticRenderFns } from "./Topnav.vue?vue&type=template&id=2076532c&scoped=true&"
import script from "./Topnav.vue?vue&type=script&lang=js&"
export * from "./Topnav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2076532c",
  null
  
)

export default component.exports